(() => {
  const reviewLayouts = new Map();
  const initReviewLayouts = root => {
    // Without ResizeObserver, retain the readable CSS grid fallback.
    if (typeof ResizeObserver === 'undefined') return;
    root.querySelectorAll('.ed-review-feed').forEach(feed => {
      if (reviewLayouts.has(feed)) return;
      const cards = [...feed.querySelectorAll('.ed-review-card')];
      let frame = 0;
      const layout = () => {
        frame = 0;
        if (!feed.isConnected) return;
        const desktop = matchMedia('(min-width: 701px)').matches;
        feed.toggleAttribute('data-ed-masonry', desktop);
        cards.forEach(card => {
          // One-pixel grid rows include the 16px space below each card.
          // DOM order stays intact; no column sorting or content truncation.
          card.style.gridRowEnd = desktop && !card.hidden
            ? `span ${Math.ceil(card.getBoundingClientRect().height + 16)}`
            : '';
        });
      };
      const schedule = () => {
        if (!frame) frame = requestAnimationFrame(layout);
      };
      const observer = new ResizeObserver(schedule);
      observer.observe(feed);
      cards.forEach(card => observer.observe(card));
      reviewLayouts.set(feed, () => {
        observer.disconnect();
        if (frame) cancelAnimationFrame(frame);
      });
      layout();
    });
  };
  const init = (root = document) => {
    root.querySelectorAll('[data-ed-filter-group]').forEach(group => {
      if (group.dataset.initialized) return;
      group.dataset.initialized = 'true';
      const filters = group.querySelector('[data-ed-filters]');
      if (!filters) return;
      const cards = [...group.querySelectorAll('[data-ed-tags]')];
      filters.hidden = false;
      filters.addEventListener('click', event => {
        const button = event.target.closest('[data-ed-filter]');
        if (!button) return;
        let count = 0;
        cards.forEach(card => {
          card.hidden = button.dataset.edFilter !== 'all' && !card.dataset.edTags.split(/\s+/).includes(button.dataset.edFilter);
          if (!card.hidden) count += 1;
        });
        filters.querySelectorAll('button').forEach(filter => filter.setAttribute('aria-pressed', String(filter === button)));
        group.querySelector('[data-ed-count]').textContent = count;
        group.querySelector('[data-ed-empty]').hidden = count !== 0;
        group.querySelector('.ed-photo-feed')?.scrollTo({ left: 0, behavior: 'instant' });
      });
    });

    initReviewLayouts(root);
    root.querySelectorAll('[data-ed-gate]').forEach(gate => {
      if (gate.dataset.initialized) return;
      gate.dataset.initialized = 'true';
      const form = gate.querySelector('form');
      const input = form.querySelector('input');
      const error = gate.querySelector('[data-ed-error]');
      const book = gate.parentElement.querySelector('[data-ed-book]');
      // Convenience gate only. The client-side value and guide source are public.
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (input.value !== 'monolith123') {
          error.hidden = false;
          input.setAttribute('aria-invalid', 'true');
          input.focus();
          return;
        }
        input.value = '';
        input.removeAttribute('aria-invalid');
        error.hidden = true;
        gate.hidden = true;
        book.hidden = false;
        book.querySelector('h1').focus();
      });
      book.querySelector('[data-ed-lock]').addEventListener('click', () => {
        book.hidden = true;
        gate.hidden = false;
        input.focus();
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    reviewLayouts.forEach((dispose, feed) => {
      if (event.target.contains(feed)) {
        dispose();
        reviewLayouts.delete(feed);
      }
    });
  });
})();
